import { IntegrityMonitorCustomRuleActionItemWebComponent } from './component/IntegrityMonitorCustomRuleActionItemWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTION_ITEM } from '../../../../webcomponents.constants';

export { IntegrityMonitorCustomRuleActionItemWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTION_ITEM,
  IntegrityMonitorCustomRuleActionItemWebComponent
);
